import { useCallback, useState } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { ServicesSection } from "../components/ServicesSection";
import { HowItWorks } from "../components/HowItWorks";
import { RequestForm } from "../components/RequestForm";
import { ContactStrip } from "../components/ContactStrip";
import { Footer } from "../components/Footer";

export default function LandingPage() {
  const [selectedService, setSelectedService] = useState("");

  const handleSelect = useCallback((name) => {
    setSelectedService(name);
    document.getElementById("deploy")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-obsidian text-foreground" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ServicesSection onSelect={handleSelect} />
        <HowItWorks />
        <RequestForm selectedService={selectedService} onServiceChange={setSelectedService} />
        <ContactStrip />
      </main>
      <Footer />
    </div>
  );
}
